import { render, staticRenderFns } from "./NewPartialSumPopup.vue?vue&type=template&id=08a0b6ba&scoped=true&"
import script from "./NewPartialSumPopup.vue?vue&type=script&lang=js&"
export * from "./NewPartialSumPopup.vue?vue&type=script&lang=js&"
import style0 from "./NewPartialSumPopup.vue?vue&type=style&index=0&id=08a0b6ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a0b6ba",
  null
  
)

export default component.exports